const faqItems = [
  {
    id: 1,
    question: '暴走黑料在线观看的内容来源可靠吗？',
    answer: '暴走黑料系列所有内容均整理自公开网络信息与媒体报道，本站作为内容聚合平台，对信息进行归类梳理和交叉比对。每条内容均标注原始来源，用户可根据标注自行核实。我们致力于提供全面、及时的黑料系列整理服务，但不对原始信息的真实性做担保。',
  },
  {
    id: 2,
    question: '黑料社在线观看与其他黑料系列有什么区别？',
    answer: '黑料社是本站旗下的特色品牌系列，专注于深度挖掘和整理当红艺人与话题人物的台前幕后故事。与暴走黑料的快节奏更新不同，黑料社在线观看更注重内容深度和多角度分析，每期围绕一个核心人物或事件展开系统梳理，适合喜欢深度吃瓜的用户。',
  },
  {
    id: 3,
    question: '本站的暴走黑料内容多久更新一次？',
    answer: '暴走黑料系列保持每日更新节奏，运营团队全天候追踪各大平台热搜、艺人动态和圈内爆料，确保用户第一时间获取最新黑料内容。重大事件发生时，我们会在2小时内整理出专题合辑。黑料社精选则为每周深度更新，每周末推出当周重磅总结。',
  },
  {
    id: 4,
    question: '如何参与投稿或提供黑料线索？',
    answer: '欢迎通过本站投稿入口提交您掌握的黑料线索或内容建议。投稿时请提供尽可能详细的信息和来源依据，我们的编辑团队会在24小时内进行审核。优质投稿将被收录至对应系列合辑中，并标注投稿人信息。请注意，投稿内容需符合相关法律法规。',
  },
  {
    id: 5,
    question: '黑料在线支持哪些设备在线观看？',
    answer: '黑料在线采用响应式设计，完美适配PC端、平板和手机端浏览。无论是暴走黑料在线观看还是黑料社在线观看，您都可以在任何设备上获得流畅的浏览体验。移动端页面针对触屏操作进行了专门优化，加载速度快，图片自适应屏幕尺寸。',
  },
  {
    id: 6,
    question: '本站的黑料内容是否涉及侵权问题？',
    answer: '本站严格遵守相关法律法规，所有整理的黑料系列内容均来源于已公开的网络信息。如权利人认为本站收录的特定内容侵犯了您的合法权益，请通过联系页面提交相关证明材料，我们将在核实后48小时内予以处理。本站始终坚持合法合规运营原则。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于暴走黑料在线观看与黑料社的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-300/60 text-foreground-500 group-open:bg-primary-500 group-open:text-background-50 transition-colors">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}